import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface SeedUserRequest {
	email: string;
	password: string;
	firstName: string;
	lastName: string;
	userType: string;
	tradingPartnerID: number | null;
	vendorID: number | null;
	signInAfterSeed: boolean;
}

export interface SeedUserResponse {
	succeeded: boolean;
	message: string;
	userID: number;
	membershipUserID: string;
	userType: string;
	tradingPartnerID: number | null;
	vendorID: number | null;
}

@Injectable({ providedIn: 'root' })
export class DevSeederService {
	private http = inject(HttpClient);

	seedUser(request: SeedUserRequest): Observable<SeedUserResponse> {
		return this.http.post<SeedUserResponse>('/api/dev/seed-user', request, { withCredentials: true });
	}

	getTradingPartners(): Observable<{ tradingPartnerID: number; name: string }[]> {
		return this.http.get<{ tradingPartnerID: number; name: string }[]>('/api/dev/trading-partners', { withCredentials: true });
	}

	getVendors(): Observable<{ vendorID: number; name: string }[]> {
		return this.http.get<{ vendorID: number; name: string }[]>('/api/dev/vendors', { withCredentials: true });
	}

	resetPassword(email: string, newPassword: string): Observable<{ succeeded: boolean; message: string }> {
		return this.http.post<{ succeeded: boolean; message: string }>('/api/dev/reset-password', { email, newPassword }, { withCredentials: true });
	}
}
